<template>
  <div>
    <h1 class="page-header">{{ $t('studyTime.studyTime') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-loading-banner :loading="loading">
          <ts-card>
            <ts-card-wrapper>
              <div class="form-group m-b-15">
                <label class="required">{{
                  $t('school.academic.operation.classOperation.weekdayType')
                }}</label>
                <select class="form-control" v-model="model.weekday_type_id" :class="{ 'is-invalid': errors.has('weekday_type_id') }">
                    <option :value="null">{{ $t('select') }}</option>
                    <option
                      v-for="(weekday_type, index) in weekday_types"
                      :value="weekday_type.id"
                      :key="index"
                    >
                      {{ weekday_type.weekday_type }} <span>{{ weekday_type.is_required_study_time ? ' (Required study time: Yes)' : ' (Required study time: No)' }}</span>
                    </option>
                  </select>
                <div class="invalid-feedback" v-if="errors.has('weekday_type_id')">
                  {{ errors.first('weekday_type_id') }}
                </div>
              </div>
              <div class="form-group m-b-15">
                <label class="required">{{ $t('studyTime.studyTime') }}</label>
                <input
                  v-model="model.study_time"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('study_time') }"
                  :placeholder="$t('studyTime.enterstudytime')"
                />
                <div class="invalid-feedback" v-if="errors.has('study_time')">
                  {{ errors.first('study_time') }}
                </div>
              </div>
              <div class="form-group">
                <label class="required">{{ $t('studyTime.session') }}</label>
              <select v-model="model.session" class="form-control">
                <option value="">{{ $t('select') }}</option>
                <option v-for="(s, index) in shifts" :key="index" :value="s.shift_en">
                  {{ s.shift_en }}
                </option>
              </select>

                <div class="invalid-feedback" v-if="errors.has('session')">
                  {{ errors.first('session') }}
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t('studyTime.numberOfSession') }}</label>
                <input
                  type="number"
                  v-model="model.number_of_session"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('number_of_session') }"
                />
                <div class="invalid-feedback" v-if="errors.has('number_of_session')">
                  {{ errors.first('number_of_session') }}
                </div>
              </div>
              <div class="form-group">
                <ts-checkbox v-model="model.visible">{{
                $t('studyTime.visible')
              }}</ts-checkbox>
              </div>
              <div class="text-right">
                <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                  {{ $t('cancel') }}
                </ts-button>
                <ts-button
                  v-if="updating"
                  class="btn-primary"
                  :waiting="waiting"
                  @click.prevent="update"
                >
                  {{ $t('update') }}
                </ts-button>
                <ts-button
                  v-if="!updating"
                  :waiting="waiting"
                  class="btn-primary"
                  @click.prevent="store"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </ts-card-wrapper>
          </ts-card>
        </ts-loading-banner>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'

export default {
  name: 'study-time-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        ac_st_id: '',
        study_time: '',
        session: '',
        number_of_session: null,
        weekday_type_id: null,
        visible: true
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      loading: false,
      shifts: []
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('studyTime', ['edit_data', 'weekday_types'])
  },
  methods: {
    fetchData(){
      return this.$store.dispatch('studyTime/paymentShift')
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('studyTime/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('studyTime/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('studyTime/SET_EDIT_DATA', {})
      this.$router.push({ name: 'study-time' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('studyTime/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
   async setEditData() {
  this.loading = true
  try {
    let response = await this.fetchData()
    // set sessions for dropdown
    this.shifts = response.payment_shifts || []

    // set model if editing
    if (!_.isEmpty(this.edit_data)) {
      this.errors = new Errors()
      this.model = _.clone(this.edit_data)
      this.updating = true
    }
  } catch (error) {
    this.$toasted.error(error.message)
  } finally {
    this.loading = false
  }
},

    clearInput() {
      this.model = {
        ac_st_id: '',
        study_time: '',
        session: '',
        number_of_session: null,
        visible: true,
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('studyTime/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
